
import { FileText } from "lucide-react";
import { TemplateCarousel } from "./TemplateCarousel";
import { ProjectTemplate } from "../types";

interface TemplateSelectorProps {
  templates: ProjectTemplate[];
  onImportClick: () => void;
  onUseTemplate: (templateName: string, templateId: number) => void;
  loading?: boolean;
}

export const TemplateSelector = ({ 
  templates, 
  onImportClick, 
  onUseTemplate, 
  loading = false 
}: TemplateSelectorProps) => {
  return (
    <div className="mb-8 sm:mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
        <div className="mb-4 sm:mb-0">
          <h2 className="text-lg sm:text-[20px] font-bold text-white">Select Project Template (Optional but recommended)</h2>
          <p className="text-gray-400 text-xs sm:text-sm mt-1">
            (Navigate using the left and right arrows, then click to select a project template . Templates can be used to fastrack creation of the project plan. Check with your administrator to load the latest project templates.)
          </p>
        </div>
      </div>
      
      <div className="min-h-[250px] sm:min-h-[200px]">
        {loading ? (
          <div className="flex items-center justify-center h-full min-h-[200px] bg-secondary-light/5 border border-primary/20 rounded-lg">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          </div>
        ) : templates.length > 0 ? (
          <TemplateCarousel templates={templates} onUseTemplate={onUseTemplate} />
        ) : (
          <div className="flex items-center justify-center h-full min-h-[200px] bg-secondary-light/5 border border-primary/20 rounded-lg">
            <div className="text-center text-gray-400">
              <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
              <p className="text-lg mb-2">No Project Templates Available</p>
              <p className="text-sm">Please contact your administrator to load project templates.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
